import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import { overallAlertSeverity } from '../../utils/AlertConfig'
import StatusIcon from '../controls/StatusIcon'
import Pluralize from '../controls/Pluralize'
import * as AlertActionCreators from '../../actions/alert'

class UnitStatusContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    unitId: PropTypes.number.isRequired,
    alerts: PropTypes.object.isRequired,
    alertsByUnit: PropTypes.object.isRequired,
    alertActions: PropTypes.object.isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: null,
  }


  static styles = (theme) => ({
    list: {
      display: 'flex',
    },
    list_icon: {
      marginRight: theme.spacing(1),
    },
  })

  static mapStateToProps(state) {
    return {
      alerts: state.alerts,
      alertsByUnit: state.alertsByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      alertActions: bindActionCreators(AlertActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { unitId, alertActions } = this.props
    alertActions.listAlertsByUnit(unitId)
  }

  unitAlerts() {
    const {
      unitId, alertsByUnit, alerts,
    } = this.props
    const alertIds = alertsByUnit[unitId] || []
    return alertIds.map((id) => (alerts[id]))
  }

  textHtml() {
    const { classes } = this.props
    const alertCount = this.unitAlerts().length
    let text = 'Normal'
    if (alertCount > 0) {
      text = <Pluralize count={alertCount} singular="Alert" />
    }
    return <Typography className={classes.list_text}>{text}</Typography>
  }

  render() {
    const {
      classes, className,
    } = this.props
    const clNames = classNames(className, classes.list_icon)
    const status = overallAlertSeverity(this.unitAlerts()).severity.text
    return (
      <div className={classes.list}>
        <StatusIcon status={status} className={clNames} />
        {this.textHtml()}
      </div>
    )
  }
}

export default connect(
  UnitStatusContainer.mapStateToProps,
  UnitStatusContainer.mapDispatchToProps,
)(withStyles(UnitStatusContainer.styles)(UnitStatusContainer))
